import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  divider: {
    color: theme.palette.primary.main
  },
  content: {
    minHeight: "100px",
    textAlign: "center",
    color: "red",
    margin: "100px"
  }
});

export const ErrorDialog = withStyles(styles)(
  ({ title, message, onClose, classes }) => (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      scroll="body"
      open
      spacing={0}
      className={classes.root}
      onClose={onClose}
    >
      <DialogTitle onCancel={onClose}>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        <Typography variant="caption">{message}</Typography>
      </DialogContent>
    </Dialog>
  )
);
